import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ChangeRequest, ChangeRequestAttachment, ChangeRequestStatus } from '../../domain/change-request-chat.model';
import { ChangeRequestChatService } from '../../services/change-request-chat.service';

@Component({
    selector: 'app-my-change-requests',
    templateUrl: './my-change-requests.component.html',
    styleUrls: ['./my-change-requests.component.scss'],
    providers: [MessageService]
})
export class MyChangeRequestsComponent implements OnInit {
    changeRequests: ChangeRequest[] = [];
    loading: boolean = true;
    selectedChangeRequest: ChangeRequest | null = null;
    detailsDialogVisible: boolean = false;

    constructor(
        private changeRequestService: ChangeRequestChatService,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        this.loadMyChangeRequests();
    }

    loadMyChangeRequests() {
        this.loading = true;
        this.changeRequestService.getMyChangeRequests().subscribe({
            next: (requests) => {
                this.changeRequests = requests.sort((a, b) => {
                    const dateA = new Date(a.RequestDate).getTime();
                    const dateB = new Date(b.RequestDate).getTime();
                    return dateB - dateA;
                });
                this.loading = false;
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load change requests'
                });
                this.loading = false;
            }
        });
    }

    showDetails(changeRequest: ChangeRequest) {
        this.selectedChangeRequest = changeRequest;
        this.detailsDialogVisible = true;
    }

    hideDetails() {
        this.detailsDialogVisible = false;
        this.selectedChangeRequest = null;
    }

    getStatusLabel(status: ChangeRequestStatus): string {
        switch (status) {
            case ChangeRequestStatus.Nieuw:       return 'New';
            case ChangeRequestStatus.InDiscussie:  return 'In Discussion';
            case ChangeRequestStatus.Goedgekeurd:  return 'Approved';
            case ChangeRequestStatus.Afgekeurd:    return 'Rejected';
            default:                               return 'Unknown';
        }
    }

    getStatusSeverity(status: ChangeRequestStatus): string {
        const severities: { [key: number]: string } = {
            0: 'info',
            1: 'warning',
            2: 'success',
            3: 'danger'
        };
        return severities[status] || 'info';
    }

    getFileIcon(contentType: string): string {
        if (contentType === 'application/pdf') {
            return 'pi pi-file-pdf';
        }
        if (contentType === 'image/jpeg' || contentType === 'image/png' || contentType?.startsWith('image/')) {
            return 'pi pi-image';
        }
        return 'pi pi-file';
    }

    downloadFile(attachment: ChangeRequestAttachment) {
        this.changeRequestService.downloadAttachment(attachment).subscribe({
            next: (blob) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = attachment.OriginalFileName || attachment.FileName;
                link.click();
                window.URL.revokeObjectURL(url);
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Download Failed',
                    detail: 'Failed to download file'
                });
            }
        });
    }
}
